import request from "@/utils/request";
import queryString from "querystring";

// 轮播图列表
export function getBannerDetail(data) {
  return request({
    url: `/client/api/b/list`,
    method: "get",
    params: data,
  });
}

// 轮播图详情
export function getBannerById(data) {
  return request({
    url: `/client/api/b/detail`,
    method: "post",
    data: queryString.stringify(data),
  });
}

// 重点项目展示/首页成果
export function getProjects(data) {
  return request({
    url: "/client/api/home/tech/home",
    method: "get",
    params: data,
  });
}
// 技术需求
export function getTechnology(data) {
  return request({
    url: "/client/api/home/need/home",
    method: "get",
    params: data,
  });
}
// 技术悬赏
export function getReward(data) {
  return request({
    url: "/client/api/home/reward/home",
    method: "get",
    params: data,
  });
}

// 成交公示
export function getPublic(data) {
  return request({
    url: "/client/api/home/publicity/home",
    method: "get",
    params: data,
  });
}

// 政策资讯-新闻
export function getNews(data) {
  return request({
    url: "/client/api/policy/news/banner/home",
    method: "get",
    params: data,
  });
}

// 政策资讯-政策
export function getPolicy(data) {
  return request({
    url: "/client/api/policy/policy/banner/home",
    method: "get",
    params: data,
  });
}

// 活动路演
export function getRodeshow(data) {
  return request({
    url: "/client/api/action/home",
    method: "get",
    params: data,
  });
}

// 友情链接
export function getFriend(data) {
  return request({
    url: "/client/api/home/friendly/home",
    method: "get",
    params: data,
  });
}
// 获取用户信息
export function getInfo(data) {
  return request({
    url: "/personal/information/get",
    method: "post",
    data: queryString.stringify(data),
  });
}
// 发布需求下拉数据
export function getSelectType(data) {
  return request({
    url: "/need/tags/list",
    method: "get",
    params: data,
  });
}
// 发布需求
export function sendNeed(data) {
  return request({
    url: "/need/add",
    method: "post",
    header: { "Content-Type": "application/json;charset=UTF-8" },
    data: data,
  });
}

// 首页检索前的下拉选
export function getSearchCat(data) {
  return request({
    url: "/api/home/search/tabs",
    method: "get",
    params: data,
  });
}

// 导航栏
export function getNavigation(data) {
  return request({
    url: "/api/home/navigation",
    method: "get",
    params: data,
  });
}

// 首页平台介绍
export function getIntroductionForHome() {
  return request({
    url: "/api/home/platform/desc",
    method: "post",
  });
}

// 关于我们详情
export function getIntroduction() {
  return request({
    url: "/client/api/home/aboutus/get",
    method: "post",
  });
}

// 首页banner下6个数据
export function getBannerData() {
  return request({
    url: "/client/api/home/datas/list",
    method: "get",
  });
}
// 热门关键词
export function getHotWords() {
  return request({
    url: `/client/api/home/hot/words`,
    method: "get",
  });
}
//企业信息获取
export function getInformation() {
  return request({
    url: "/mine/info/getInfo",
    method: "get",
  });
}
